<template>
  <v-dialog
    v-model="dialogModel"
    transition="scroll-x-transition"
    overlay-color="grey darken-2"
    content-class="ec-confirmation-dialog overflowY-auto"
    width="600"
    persistent
  >
    <v-card color="accent" width="600">
      <v-card-title dark style="background-color: #47bd96; color: white">
        {{ quoteConnectionType.text }} connection properties:
      </v-card-title>
      <v-card-text class="pb-0 pt-5 text-center">
        <v-form ref="quoteConnectionform" v-model="valid" lazy-validation>
          <v-row>
            <v-col
              v-for="field in connectionFields"
              :key="field.text"
              cols="12"
              sm="6"
              class="pb-0 pt-1"
            >
              <v-select
                v-if="field.name === 'EncryptMethod'"
                outlined
                dense
                :menu-props="{
                  offsetY: true,
                  maxHeight: '250',
                }"
                label="Encryption method"
                v-model="field.value"
                :items="currentEncryptionMethods"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    class="px-2"
                    style="max-height: 40px; border-bottom: 1px solid #7f7f7f"
                    ripple
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px !important; font-weight: 400"
                      >

                      <v-row
                        class="mx-1 mt-1 mb-0"
                        style="border-top: none !important"
                      >
                      <v-btn @click="addNewEncryptMethod" text small class="mt-2 px-2"> 
                        <i
                          style="color: #47bd96"
                          class="fas fa-plus-circle mr-1"
                        ></i>
                        New method
                      </v-btn>
                        <v-text-field
                          v-model="newEncryptionMethod"
                          class="mini-text-field ml-3"
                          style="width: 84px !important;margin-top:8px;"
                          outlined
                          dense
                          placeholder="..."
                          hide-details
                        ></v-text-field>
                      </v-row>

                        <!-- <v-row class="mx-0">
                          <i
                            style="color: #47bd96"
                            class="fas fa-plus-circle mr-1 mt-3"
                          ></i>
                          <p class="mt-3">New method</p>
                          <v-text-field
                            v-model="newEncryptionMethod"
                            class="mini-text-field mx-3"
                            style="width: 74px !important"
                            outlined
                            dense
                            label="..."
                          ></v-text-field>
                        </v-row> -->
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
              <v-select
                v-else-if="field.type === 'boolean'"
                outlined
                dense
                :menu-props="{ offsetY: true }"
                item-text="text"
                :label="field.text"
                v-model="field.value"
                :items="[
                  { value: true, text: 'Yes' },
                  { value: false, text: 'No' },
                ]"
              >
                <template v-slot:item="{ item }">
                  <p class="mb-0">{{ item.text }}</p>
                </template>
              </v-select>
              <v-text-field
                v-else-if="field.type === 'number'"
                dense
                outlined
                :label="field.text"
                v-model.number="field.value"
                type="number"
                :rules="[field.required ? rules.required : true]"
              ></v-text-field>
              <v-text-field
                v-else
                dense
                outlined
                :label="field.text"
                v-model="field.value"
                :rules="[field.required ? rules.required : true]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn text @click="cancelQuoteConnectionDialog">Cancel</v-btn>
        <!-- <v-btn color="primary" text @click="() => {}">Save</v-btn> -->
        <v-btn
          @click="saveQuoteConnectionProperties()"
          color="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    currentDefinition: {
      type: Object,
      default: () => {},
    },
    currentEncryptionMethods: {
      type: Array,
      default: () => [],
    },
    quoteConnectionEditDialog: {
      type: Boolean,
      default: false,
    },
    quoteConnectionType: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    newEncryptionMethod: null,
    connectionFields: [],
    valid: true,
    applications: [],
    FixFields: [
      {
        value: 10000,
        text: "Reconnect Time",
        name: "ReconnectTime",
        type: "number",
      },
      {
        value: 2147483647,
        text: "Max Reconnect Retries",
        name: "MaxReconnectRetries",
        type: "number",
      },
      {
        value: "",
        text: "File Store Path",
        name: "FileStorePath",
        type: "string",
      },
      {
        value: "",
        text: "File Log Path",
        name: "FileLogPath",
        type: "string",
      },
      {
        value: "",
        text: "Socket Connect Host",
        name: "SocketConnectHost",
        type: "string",
        required: true,
      },
      {
        value: null,
        text: "Socket Connect Port",
        name: "SocketConnectPort",
        type: "number",
        required: true,
      },
      {
        value: "00:00:00",
        text: "Start Time",
        name: "StartTime",
        type: "string",
      },
      {
        value: "00:00:00",
        text: "End Time",
        name: "EndTime",
        type: "string",
      },
      {
        value: 30,
        text: "Heartbeat Interval",
        name: "HeartBtInt",
        type: "number",
      },
      {
        value: true,
        text: "Reset On Logon",
        name: "ResetOnLogon",
        type: "boolean",
      },
      {
        value: "FIX.4.4",
        text: "Begin String",
        name: "BeginString",
        type: "string",
      },
      {
        value: "",
        text: "Sender Comp ID",
        name: "SenderCompID",
        type: "string",
        required: true,
      },
      {
        value: "",
        text: "Target Comp ID",
        name: "TargetCompID",
        type: "string",
        required: true,
      },
      {
        value: 0,
        text: "Encrypt Method",
        name: "EncryptMethod",
        type: "number",
        required: true,
      },
      {
        value: "",
        text: "Username",
        name: "Username",
        type: "string",
        required: true,
      },
      {
        value: "",
        text: "Password",
        name: "Password",
        type: "string",
        required: true,
      },
      {
        value: false,
        text: "Password Encrypted",
        name: "PasswordEncrypted",
        type: "boolean",
      },
    ],
    WebSocketFields: [
      {
        value: "",
        text: "URL Address",
        name: "url",
        type: "string",
      },
    ],
    rules: {
      required: (val) => {
        if (!!val || val === 0) {
          return true;
        } else return "Required";
      },
    },
  }),
  computed: {
    dialogModel: {
      get() {
        return this.quoteConnectionEditDialog;
      },
      set(v) {
        this.$emit("update-quote-dialog", v);
      },
    },
  },
  methods: {
    addNewEncryptMethod() {
      if(typeof this.newEncryptionMethod != "string") return
      this.$emit('add-encryption-method', this.newEncryptionMethod)
      // this.currentEncryptionMethods.push(this.newEncryptionMethod)
    },
    saveQuoteConnectionProperties() {
      if (!this.$refs.quoteConnectionform.validate()) return;
      this.$emit("save-quote-connection", this.connectionFields);
      this.dialogModel = false;
    },
    resetFormValidation() {
      this.$refs.quoteConnectionform.resetValidation();
    },
    cancelQuoteConnectionDialog() {
      this.dialogModel = false;
    },
    clearDialog() {
      this.resetFormValidation();
      this.newEncryptionMethod = null
    },
  },
  watch: {
    quoteConnectionType: {
      handler(v) {
        if (typeof v == "object" && v.hasOwnProperty("value")) {
          // currentDefinition.configuration
          this.connectionFields =
            v.value === "Fix"
              ? JSON.parse(JSON.stringify(this.FixFields))
              : JSON.parse(JSON.stringify(this.WebSocketFields));

          // To Do:
          //  Test the population of the quote connection fields when editing the configuration.
          this.connectionFields = this.connectionFields.map(el => {
            if(this.currentDefinition.configuration[v.value]) {
              el.value = this.currentDefinition.configuration[v.value][el.name]
            }
            return el
          })
        }
      },
      deep: true,
    },
    connectionFields() {
      return this.quoteConnectionType.value === "Fix"
        ? this.FixFields
        : this.WebSocketFields;
    },
    dialogModel(v) {
      if (!v) {
        this.clearDialog();
      }
    },
  }
};
</script>
